import ReactDOM from "react-dom";
import { AiOutlineClose } from "react-icons/ai";
import Button from "../button";

const dialogRoot = document.createElement("div");

interface IDialog {
  closable?: boolean;
  title: string;
  content: any;
  actions?: {
    label: string;
    onClick?: () => void;
    type?: "danger" | "primary";
  }[];
}

const Dialog = (props: IDialog) => {
  const { title, content, actions = [], closable = true } = props;
  const theme = localStorage.getItem("sh_theme");
  document.documentElement.style.overflow = "hidden";

  ReactDOM.render(
    <>
      <div className="opacity-75 fixed inset-0 modal-overlay bg-black sh-z-dialog" />
      <div
        className={`${theme} sh-modal-animation flex justify-center top-1/4 w-screen fixed sh-z-dialog`}
        style={{ zIndex: 5000 }}
      >
        <div
          className={`bg-white sh-modal-animation rounded-sm p-2`}
          style={{
            zIndex: 6000,
            minHeight: 100,
            height: "auto",
            maxHeight: 700,
            minWidth: 300,
            width: "auto",
            maxWidth: "50%",
          }}
        >
          <div
            className={`flex gap-3 justify-between mb-3 align-middle items-center border-b pb-2`}
          >
            <article className={`sh-primary-text text-xl uppercase`}>
              {title}
            </article>
            {!closable ? null : (
              <AiOutlineClose
                className="select-none text-red-600 text-center hover:text-red-800 sh-feedback rounded-full h-6 w-6 text-1xl p-1"
                onClick={() => {
                  ReactDOM.unmountComponentAtNode(dialogRoot);
                  document.documentElement.style.overflow = "auto";
                }}
              />
            )}
          </div>
          <div className={` sh-secondary-text my-4`}>{content}</div>
          <div className="flex gap-x-3 justify-end mt-2">
            {actions.map(({ label, onClick = () => {}, type }, index) => (
              <Button
                key={`${label}-${index}`}
                type={type}
                label={label}
                onClick={() => {
                  ReactDOM.unmountComponentAtNode(dialogRoot);
                  document.documentElement.style.overflow = "auto";
                  onClick();
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </>,
    document.getElementById("root")!.appendChild(dialogRoot)
  );
};

export default Dialog;
